import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { RedirectToLogin } from '@/components/redirect-to-login';
import { ErrorSection } from '@/components/sections/error-section';
import { SplashScreen } from '@/components/splashes/splash-screen';
import { Button } from '@/components/ui/button';

export function NotFoundPage(): ReactElement {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { t } = useTranslation('errors');

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    return <RedirectToLogin />;
  }

  return (
    <ErrorSection
      action={
        <Button>
          <Link to={user ? '/purchase-planning' : '/'}>
            {t('Go back to purchase planning')}
          </Link>
        </Button>
      }
      code={404}
      description={t('We could not find the page')}
      title={t('Page not found')}
    />
  );
}
